var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_ppt") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Documents",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-30.000000, -132.000000)",
    fill: "#D74F29",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.8,142.4 L39.3,142.4 C40.8,142.4 41.46,142.12 42.1,141.58 C42.74,141.03 43,140.25 43,139.23 C43,138.26 42.75,137.5 42.1,136.88 C41.45,136.29 40.83,136 39.3,136 L35,136 L35,146 L36.8,146 L36.8,142.4 L36.8,142.4 Z M46,132 C47.1045695,132 48,132.895431 48,134 L48,148 C48,149.104569 47.1045695,150 46,150 L32,150 C30.8954305,150 30,149.104569 30,148 L30,134 C30,132.89 30.9,132 32,132 L46,132 L46,132 Z M36.8,141 L36.8,137.4 L39.1,137.4 C39.76,137.4 40.27,137.65 40.6,138 C40.93,138.35 41.1,138.72 41.1,139.24 C41.1,139.8 40.92,140.19 40.6,140.5 C40.28,140.81 39.9,141 39.22,141 L36.8,141 Z",
    id: "icon_ppt"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.f65dbec7193dd104e388401c8db3e17c.svg";
export { ForwardRef as ReactComponent };